/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Referral/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import ReferralType from './ReferralType/index'
import RemoveAction from './RemoveAction/index'
import Source from './Source/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Referral({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Referral.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-ZLvzN1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-2-ZLvzN1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-3-ZLvzN1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Referral.Horizontal"
  data-view-path={viewPath}
 style={{'--g-3-ZLvzN1': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<ReferralType
  viewPath={`${viewPath}/ReferralType`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
<Source
  viewPath={`${viewPath}/Source`}
/>
</div>
{children}
</React.Fragment>)
}